import { ModalFactory } from '@vend/vend.ui'

export class AccountBalanceSetupModalService {
  constructor(private readonly Modal: ModalFactory) {
    'ngInject'
  }

  public openModal() {
    return this.Modal({
      controller: 'accountBalanceSetupModalController',
      controllerAs: '$ctrl',
      template: `<account-balance-setup-modal close="$ctrl.internalClose"></account-balance-setup-modal>`,
    })
  }
}
